export const CancelCommandName = 'CancelCommandComponent';
